import { Injectable, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { SiaSliderComponent } from '@sia/inputs';
import { SiaGridAvatarComponent } from '@sia/shared';

@Injectable({
  providedIn: 'root',
})
export class SiaTemplateService {
  constructor(private injector: Injector) {
    if (!customElements.get('template-divider')) {
      const dividerElement = createCustomElement(MatDivider, {
        injector: this.injector,
      });
      customElements.define('template-divider', dividerElement);
    }
    if (!customElements.get('template-icon')) {
      const iconElement = createCustomElement(MatIcon, {
        injector: this.injector,
      });
      customElements.define('template-icon', iconElement);
    }
    if (!customElements.get('template-checkbox')) {
      const checkBoxElement = createCustomElement(MatCheckbox, {
        injector: this.injector,
      });
      customElements.define('template-checkbox', checkBoxElement);
    }
    if (!customElements.get('template-avatar')) {
      const avatarElement = createCustomElement(SiaGridAvatarComponent, {
        injector: this.injector,
      });
      customElements.define('template-avatar', avatarElement);
    }
    if (!customElements.get('template-slider')) {
      const sliderElement = createCustomElement(SiaSliderComponent, {
        injector: this.injector,
      });
      customElements.define('template-slider', sliderElement);
    }
    if (!customElements.get('template-button')) {
      const buttonElement = createCustomElement(MatButton || MatIconButton, {
        injector: this.injector,
      });
      customElements.define('template-button', buttonElement);
    }
  }
}
